/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretRight: {
  name: 'caret_right';
  data: string;
} = {
  name: 'caret_right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.47 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>`
};
